import React from 'react';
import { Phone } from 'lucide-react';

export const TopBanner = () => {
  return (
    <div className="bg-amber-600 text-white py-3 px-6">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6">
        <div className="flex items-center gap-2">
          <Phone className="h-5 w-5 animate-pulse" />
          <span className="font-semibold text-lg">Call Us Now:</span>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4">
          <a 
            href="tel:6045680063"
            className="text-2xl font-bold hover:underline transition-all"
          >
            604-568-0063
          </a>
          <span className="hidden sm:inline text-slate-200">|</span>
          <a 
            href="tel:6042032008"
            className="text-xl font-semibold hover:underline transition-all"
          >
            604-203-2008
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBanner;
